import { Component, OnInit } from "@angular/core";
import { SeoServiceService } from "src/app/services/seo-service.service";

@Component({
  selector: "app-social-initiative",
  templateUrl: "./social-initiative.component.html",
  styleUrls: ["./social-initiative.component.scss"],
})
export class SocialInitiativeComponent implements OnInit {
  constructor(private seoService: SeoServiceService) { }

  ngOnInit(): void {
    this.seoService.createLinkForCanonicalURL();
  }

  data = [
    "At VIRSA, we not only provide Interactive Flat Panels (IFP), IFP Safety Shutters, All-in-One PCs, LMS, and Digital K–12 solutions to the masses, but also extend these initiatives to underprivileged communities through our NGO arm, Routes 2 Roots.",
    "Through our social initiatives, we contribute our resources, efforts, and commitment to make a meaningful difference. Our core objective is to touch the soul of every human being by offering wellness and happiness solutions through art and culture.Routes 2 Roots, an NGO actively engaged in cultural exchange programs in India and abroad since 2004, has pioneered peace-building efforts through cultural exchange.",
    "We maintain the highest standards of digital learning in performing arts and actively contribute to the upliftment of society. To date, Routes 2 Roots has reached 22,000 schools and impacted the lives of over 22 million people, making it a one-of-a-kind initiative that creates a level playing field for children in India and across the world.",
    "A highly motivated team works tirelessly for this cause, striving to empower the next generation with essential life skills to help create a better and more inclusive world.",
  ];
}
